import React from 'react'
import {Icon} from '@chakra-ui/react'

const ShippingIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M31.3534 31.5536C27.1354 31.5536 23.7158 28.1247 23.7158 23.9066C23.7158 19.6886 27.1447 16.269 31.3534 16.269C35.5621 16.269 39.0004 19.698 39.0004 23.9066C39.0004 28.1153 35.5714 31.5536 31.3534 31.5536ZM31.3534 18.1479C28.1781 18.1479 25.5947 20.7313 25.5947 23.9066C25.5947 27.0819 28.1781 29.6747 31.3534 29.6747C34.5287 29.6747 37.1215 27.0913 37.1215 23.9066C37.1215 20.7219 34.5381 18.1479 31.3534 18.1479Z"
                fill="currentColor"
            />
            <path
                d="M30.7988 25.8043C30.2821 25.8043 29.8594 25.3816 29.8594 24.8649V20.6656C29.8594 20.1489 30.2821 19.7262 30.7988 19.7262C31.3155 19.7262 31.7382 20.1489 31.7382 20.6656V24.8649C31.7382 25.3816 31.3155 25.8043 30.7988 25.8043Z"
                fill="currentColor"
            />
            <path
                d="M34.6787 25.8983H30.7988C30.2821 25.8983 29.8594 25.4755 29.8594 24.9588C29.8594 24.4422 30.2821 24.0194 30.7988 24.0194H34.6787C35.1953 24.0194 35.6181 24.4422 35.6181 24.9588C35.6181 25.4755 35.1953 25.8983 34.6787 25.8983Z"
                fill="currentColor"
            />
            <path
                d="M31.0994 35.0388H1.93943C1.42274 35.0388 1 34.6161 1 34.0994V4.93943C1 4.42274 1.42274 4 1.93943 4H31.0994C31.6161 4 32.0388 4.42274 32.0388 4.93943V17.0299C32.0388 17.5466 31.6161 17.9693 31.0994 17.9693C30.5827 17.9693 30.16 17.5466 30.16 17.0299V5.87886H2.87886V33.16H30.16V30.7174C30.16 30.2007 30.5827 29.778 31.0994 29.778C31.6161 29.778 32.0388 30.2007 32.0388 30.7174V34.0994C32.0388 34.6161 31.6161 35.0388 31.0994 35.0388Z"
                fill="currentColor"
            />
            <path
                d="M12.414 17.0487C12.2449 17.0487 12.0852 17.0017 11.9349 16.9172C11.6531 16.7481 11.4746 16.4381 11.4746 16.1093V5.1461C11.4746 4.62941 11.8974 4.20667 12.414 4.20667H20.7186C21.2353 4.20667 21.658 4.62941 21.658 5.1461V16.1187C21.658 16.4475 21.4796 16.7575 21.1977 16.9266C20.9159 17.0957 20.5589 17.1051 20.2677 16.9454L16.51 14.9162L12.865 16.936C12.7241 17.0111 12.5644 17.0581 12.4046 17.0581L12.414 17.0487ZM16.51 12.8964C16.6603 12.8964 16.82 12.934 16.9515 13.0091L19.7792 14.531V6.08553H13.3535V14.5216L16.059 13.0185C16.2 12.9434 16.3597 12.8964 16.5194 12.8964H16.51Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ShippingIcon
